import { type FC, type MouseEvent, useState } from 'react'
import { useIntl } from 'react-intl'
import { IconButton, type IconButtonProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import { svgLazyLoader } from '@Utils/icons'

import * as styles from './styles'

const RoundTripIcon = svgLazyLoader('navigationAndAction/roundtrip')

export type SwapProps = IconButtonProps & {
  isHorizontal?: boolean
  ariaLabelOrigin?: string
  ariaLabelDestination?: string
}

const Swap: FC<SwapProps> = ({
  ariaLabelOrigin,
  ariaLabelDestination,
  isHorizontal = false,
  onClick,
  disabled,
  ...rest
}) => {
  const [animationPlayState, setAnimationPlayState] = useState<AnimationPlayState>('idle')
  const theme = useTheme()
  const { formatMessage } = useIntl()

  const DEFAULT_EMPTY_LABEL = formatMessage({ id: 'accessibility_swapOd_defaultEmpty_SrLabel' })

  const runAnimation = () => setAnimationPlayState('running')

  const finishAnimation = () => setAnimationPlayState('finished')

  return (
    <IconButton
      {...rest}
      onClick={(event: MouseEvent<HTMLButtonElement>) => {
        runAnimation()
        onClick?.(event)
      }}
      onAnimationEnd={finishAnimation}
      css={styles.swapButton(theme)}
      aria-label={formatMessage(
        { id: 'accessibility_swapOd_SrLabel' },
        { origin: ariaLabelOrigin || DEFAULT_EMPTY_LABEL, destination: ariaLabelDestination || DEFAULT_EMPTY_LABEL },
      )}
      size="large"
    >
      <RoundTripIcon css={styles.swapIcon(theme, animationPlayState, isHorizontal, disabled)} />
    </IconButton>
  )
}

export default Swap
